import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";

const AdminSidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
    const [openDropdowns, setOpenDropdowns] = useState({
        MyProject: false,
        Profile: false,
        AiThings: false,
        DigitalMarketing: false,
        InProgress: false
    });

    const user = JSON.parse(localStorage.getItem("user"));
    const userRole = user?.role || '';
    const navigate = useNavigate();
    const location = useLocation();

    const toggleDropdown = (section) => {
        setOpenDropdowns((prev) => ({ ...prev, [section]: !prev[section] }));
    };

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("isAuthenticated");
        localStorage.removeItem("clientEmail");
        localStorage.removeItem("userId");
        sessionStorage.clear();
        navigate("/");
    };

    const scrollSidebarTop = () => {
        const sidebar = document.getElementById('dashboard-sidebar');
        if (sidebar) sidebar.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const scrollSidebarBottom = () => {
        const sidebar = document.getElementById('dashboard-sidebar');
        if (sidebar) sidebar.scrollTo({ top: sidebar.scrollHeight, behavior: 'smooth' });
    };

    const renderMenuGroup = (heading, key, items) => (
        <div className="space-y-1">
            <div
                className="flex items-center justify-between cursor-pointer px-4 py-2 bg-gray-800 rounded"
                onClick={() => toggleDropdown(key)}
            >
                <span className="font-semibold text-white">{heading}</span>
                <span>{openDropdowns[key] ? '▲' : '▼'}</span>
            </div>
            {openDropdowns[key] && (
                <ul className="ml-4 mt-2 space-y-1">
                    {items.map(item => (
                        (!item.hideFor || !item.hideFor.includes(userRole)) && (
                            <li key={item.key}>
                                <Link
                                    to={item.path}
                                    onClick={() => setIsSidebarOpen(false)}
                                    className={`block px-3 py-2 rounded text-sm ${location.pathname === item.path ? 'bg-green-600 text-white' : 'text-gray-300 hover:bg-gray-700'
                                        }`}
                                >
                                    {item.label}
                                </Link>
                            </li>
                        )
                    ))}
                </ul>
            )}
        </div>
    );

    return (
        <aside
            id="dashboard-sidebar"
            className={`fixed inset-y-0 left-0 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                } transition-transform duration-300 ease-in-out w-64 bg-gray-900 text-white flex flex-col py-6 px-4 space-y-4 z-50 overflow-y-auto`}
            style={{ maxHeight: '100vh' }}
        >
            <div className="flex justify-between mb-2">
                <button onClick={scrollSidebarTop} className="bg-gray-700 ml-12 text-white px-2 py-1 rounded hover:bg-gray-600 text-xs">▲ Top</button>
                <button onClick={scrollSidebarBottom} className="bg-gray-700 text-white px-2 py-1 rounded hover:bg-gray-600 text-xs">▼ Bottom</button>
            </div>

            <Link to="/DashBoard" className="text-sm text-gray-300 hover:text-white ml-12">Home/</Link>
            <hr className="border-gray-700" />

            {renderMenuGroup("Profile", "Profile", [
                { key: 'Profile', label: 'Profile', path: '/admin-profile' },
                { key: 'Workspace', label: 'Workspace', path: '/DashBoard' },
                { key: 'DoToDo', label: 'DoToDo', path: '/dotodo', hideFor: ['Developer'] },
                { key: 'AppointmentList', label: 'Appointments List', path: '/appointments', hideFor: ['Developer'] },
                { key: 'FestivalInformer', label: 'Festival Informer', path: '/festival-informer', hideFor: ['Developer'] },
                { key: 'Leads', label: 'Leads', path: '/leads', hideFor: ['Developer'] },
                { key: 'HostChecker', label: 'HostChecker', path: '/host-checker', hideFor: ['Developer'] },
                { key: 'NotificationManager', label: 'Notification Manager', path: '/notifications' },
                { key: 'AboutThis', label: 'About This App', path: '/about' },
            ])}

            {renderMenuGroup("MyProject", "MyProject", [
                { key: 'MyClients', label: 'My Clients', path: '/myclients', hideFor: ['Developer'] },
                { key: 'MyProject', label: 'My Project', path: '/Cases' },
                { key: 'Hearings', label: 'Hearings', path: '/hearings', hideFor: ['Developer'] },
                { key: 'timesheet', label: 'Timesheet', path: '/timesheets', hideFor: ['Developer'] },
                { key: 'documents', label: 'Documents', path: '/documents', hideFor: ['Developer'] },
                { key: 'Requirements', label: 'Requirements', path: '/requirements', hideFor: ['Developer'] },
            ])}

            {/* Simplified for brevity in this first pass, duplicating structure from DashBoard.js */}
            {renderMenuGroup("AiThings", "AiThings", [
                { key: 'ExcelGen', label: 'Excel Generator', path: '/excel-gen' },
                { key: 'BlogGenerator', label: 'Blog Generator', path: '/blog-gen' },
                { key: 'Reader', label: 'Number Extractor', path: '/reader', hideFor: ['Developer'] },
                { key: 'ImageGen', label: 'Image Generator', path: '/image-gen', hideFor: ['Developer'] },
                { key: 'InvoiceGenerator', label: 'Invoice Generator', path: '/invoice-gen', hideFor: ['Developer'] },
                { key: 'AiGenerators', label: 'Mannual Ai Generators ', path: '/ai-generators' },
            ])}

            {renderMenuGroup("DigitalMarketing", "DigitalMarketing", [
                { key: 'LeadGen', label: 'LeadGenerator', path: '/lead-gen', hideFor: ['Developer'] },
                { key: 'WebsiteList', label: 'Website Checker', path: '/website-list', hideFor: ['Developer'] },
                { key: 'DocumentLists', label: 'Document Lists', path: '/document-lists', hideFor: ['Developer'] },
                { key: 'SocialMediaUploader', label: 'Social Media Uploader', path: '/sm-uploader', hideFor: ['Developer'] },
                { key: 'LockerData', label: 'LockerStudio DataAnalzyer', path: '/locker-data' },
                { key: 'NewsLetter', label: 'News Letter', path: '/newsletter', hideFor: ['Developer'] },
                { key: 'EmailMarketing', label: 'EmailMarketing', path: '/email-marketing', hideFor: ['Developer'] },
            ])}

            {renderMenuGroup("InProgress", "InProgress", [
                { key: 'GMB', label: 'GMB', path: '/gmb', hideFor: ['Developer'] },
                { key: 'ReviewsList', label: 'Reviews List', path: '/reviews' },
                { key: 'Agent', label: 'Agent', path: '/agent' },
                { key: 'OneBot', label: 'OneBot', path: '/onebot' },
                { key: 'AllInOne', label: 'Perfect Blogger', path: '/all-in-one', hideFor: ['Developer'] },
            ])}

            <hr className="border-gray-700" />
            <button
                onClick={handleLogout}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
            >
                Logout
            </button>
        </aside>
    );
};

export default AdminSidebar;
